import React from 'react';
import { useTranslation } from 'react-i18next';

const WhatWeDo3 = () => {
    const { t } = useTranslation();

    return (
        <div className="about-statement mobile-page-padding">
            <div className="container">
                <div className="about-statement-inner">
                    <div className="about-statement-mark" />
                    <p>{t('pages.about.whatWeDo.heading')}</p>
                </div>
            </div>
        </div>
    );
};

export default WhatWeDo3;
